export const OnlinePaymentConfirmationPageTemplate = {
    slots: ['SlbNewPaymentConfirmationContainerSlot'],
};